module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-level-selector"
  }, [_c('div', {
    staticClass: "user-level-selector__label"
  }, [_c('span', {
    class: {
      'active': _vm.dropdownOpen === true
    },
    on: {
      "click": function($event) {
        _vm.toggleDropdown()
      }
    }
  }, [_vm._v(_vm._s(_vm.userLevel))]), _vm._v(" "), _c('span', {
    class: {
      'chevron': _vm.dropdownOpen === true
    }
  })]), _vm._v(" "), (_vm.dropdownOpen === true) ? _c('div', {
    staticClass: "user-level-selector__dropdown"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        _vm.saveUserLevel('admin')
      }
    }
  }, [_vm._v("Administator")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        _vm.saveUserLevel('standard')
      }
    }
  }, [_vm._v("Standard User")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v("Select user role "), _c('span', {
    staticClass: "chevron"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d9a329e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/UserLevelSelector/UserLevelSelector.vue
// module id = 560
// module chunks = 1